import type { Row } from './db';

const num = (v: unknown): number | null => (typeof v === 'number' ? v : null);

/** Public-site order: ascending `order`, unordered rows last, then oldest first. */
export function sortByOrder(rows: Row[]): Row[] {
  const created = (r: Row) => {
    const c = r.createdAt as { toMillis?: () => number } | undefined;
    return c?.toMillis ? c.toMillis() : 0;
  };
  return [...rows].sort((a, b) => {
    const ao = num(a.order) ?? Number.POSITIVE_INFINITY;
    const bo = num(b.order) ?? Number.POSITIVE_INFINITY;
    return ao === bo ? created(a) - created(b) : ao < bo ? -1 : 1;
  });
}

/** Order for a new row: after everything that already has one. */
export function nextOrder(rows: Row[]): number {
  return rows.reduce((m, r) => Math.max(m, num(r.order) ?? 0), 0) + 1;
}
